export const PASSWORD_POLICY_REGEX =
  /^((?=\S*?[A-Z])(?=\S*?[a-z])(?=\S*?[0-9])(?=\S*?[.*&^%$#@!~]).{8,})\S?$/;
